<template>
    <div class="categoryListBox">
        <div class="descktopMediaBox">
            <div class="menuBanner">
                <img :src="getStaticImage('landingpage-min.jpg')">
            </div>
            <div class="container">
                <div class="menuTitle">
                    <div class="h1 text-center">{{ settings.title }}</div>
                    <div class="breadCr">
                        <router-link :to="{name: 'Home'}">Home</router-link> <span>/</span>
                        <div>Menu</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="searchField">
                        <input name="item" type="text" placeholder="Search for an item..." v-model.lazy.trim="search.query" @change="queryChange">
                    </div>
                    <h2 class="mediaHideOnDesctop">Categories</h2>
                </div>
            </div>
        </div>
        
        <div class="categoryList">
            <div
                class="catEl"
                v-for="(m,index) in menu"
                @click="$router.push({name:'Menu', params: { business_id: bId} , query: {category: m.id}})"
                :key="index"
            >
                <div class="frame" v-if="m.category_url" :style="{backgroundImage: `url(${m.category_url})`}"></div>
                <div class="frame" v-else-if="!$route.query.category" :style="{backgroundImage: `url(${getStaticImage('def_img.jpg')})`}"></div>
                <div class="title h4">
                    {{ m.name }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "CategoryMenu",
        props: ["menu"],
        methods:{
            queryChange(){
                this.$router.push({name:'Menu', params: { business_id: this.bId} ,query: {search: this.search.query}});
            }
        },
        computed:{
            ...mapState("menu",["search"]),
            settings() {
                return this.$store.state.shared.topBar;
            },
            bId(){
                return this.$store.state.shared.businessId;
            }
        }
    }
</script>
